import { startTransition, useEffect, useState } from 'react';

import { SCREENS } from './utils';

type UseMediaQueryParams =
  | { screen: keyof typeof SCREENS | number; query?: never }
  | { screen?: never; query: string };

export const useMediaQuery = ({ screen, query }: UseMediaQueryParams) => {
  const [matches, setMatches] = useState(false);
  const [hasRun, setHasRun] = useState(false);

  let queryString = '';
  if (screen) {
    const width = typeof screen === 'number' ? `${screen}px` : SCREENS[screen];
    queryString = `(min-width: ${width})`;
  } else if (query) {
    queryString = query;
  }

  useEffect(() => {
    startTransition(() => {
      setHasRun(true);
      const media = window.matchMedia(queryString);
      if (media.matches !== matches) {
        setMatches(media.matches);
      }
    });

    const media = window.matchMedia(queryString);
    const listener = () => {
      startTransition(() => {
        setMatches(media.matches);
      });
    };
    media.addEventListener('change', listener);

    return () => {
      media.removeEventListener('change', listener);
    };
  }, [matches, query, queryString]);

  return [matches, hasRun];
};
